var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.badge)?_c('div',{staticClass:"badge"},[_c('img',{attrs:{"src":_vm.badge}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }